// CheckCandidateStage.jsx

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import axios from "axios";
import styles from "./CheckCandidateStage.module.scss";
import { AiOutlineClose } from "react-icons/ai";
import { newPipelinestagesCheck } from "../../../services/candidateServices";
import { dateFormateDD, decryptedAdminID, textTruncate } from "../../../utility";
import { useSelector } from "react-redux";

const CheckCandidateStage = ({ onClose }) => {
  // const [showInput, setShowInput] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [error, setError] = useState("");
    const adminDetailsRole = useSelector((state) => state.adminDetails);
  let isSuperAdmin = adminDetailsRole.roleID === 1;
    const isTeamLeader = localStorage.getItem("teamLeader") == "true";

  // ==========================================
  // API CALL
  // ==========================================
  const handleCheck = async () => {
    try {
      setError("");

      if (mobileNumber.length !== 10) {
        return setError(
          "Enter valid 10 digit mobile number"
        );
      }

      setLoading(true);

      const response =  await newPipelinestagesCheck({
          mobile_number: mobileNumber,
        });

      setResponseData(response.data);
    } catch (err) {
      console.log(err);

      setResponseData(null);

      setError(
        err?.response?.data?.message ||
          "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  // ==========================================
  // FORMAT DATE
  // ==========================================
  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString("en-IN");
  };
const isCurrentAdmin = responseData?.data?.assign_to_name === localStorage.getItem("adminuserName");
// console.log(isCurrentAdmin,"isCurrentAdmin");

  return (
    <div className={styles.container}>

      
<div className={styles.header} >
  <span><b>Mobile Number Filter</b></span>
  <button onClick={onClose} className="btn btn-danger"><AiOutlineClose/></button>
</div>
     <div className={styles.containerData} >
       {/* INPUT */}
        <div className={styles.inputWrapper}>
          <input
            type="text"
            placeholder="Enter Mobile Number"
            value={mobileNumber}
            maxLength={10}
            onChange={(e) => {
              const value =
                e.target.value.replace(/\D/g, "");

              setMobileNumber(value);
            }}
            className={styles.input}
          />

          <button
            onClick={handleCheck}
            disabled={loading}
            className={styles.checkButton}
          >
            {loading ? "Checking..." : "Check"}
          </button>
        </div>

      {/* ERROR */}
      {error && (
        <p className={styles.error}>
          {error}
        </p>
      )}

      {/* RESPONSE */}
      {responseData?.success && (
        <div className={styles.card}>

          <h3 className={styles.title}>
            Candidate / Lead Details
          </h3>

          {/* <div className={styles.row}>
            <span>Status</span>
            <span>{responseData.message}</span>
          </div>

          <div className={styles.row}>
            <span>Source</span>
            <span>{responseData.source}</span>
          </div> */}

          {responseData.source ===
            "candidate" && (
            <div className={styles.row}>
              <span>Interview</span>

              <span>
                {responseData.interview_available
                  ? "Available"
                  : "Not Available"}
              </span>
            </div>
          )}

          {(isSuperAdmin||isTeamLeader||isCurrentAdmin) && (
            <div className={styles.row}>
              <span>Assigned To</span>

              <span>
                {responseData?.data
                  ?.assign_to_name || "-"}
              </span>
            </div>
          )}

          <div className={styles.row}>
            <span>Current Stage</span>

            <span>
              {responseData?.data
                ?.current_stage_name || "-"}
            </span>
          </div>

          <div className={styles.row}>
            <span>Current Sub Stage</span>

            <span>
              {responseData?.data
                ?.current_sub_stage_name || "-"}
            </span>
          </div>

          {/* {responseData.source ===
          "candidate" ? (
            <div className={styles.row}>
              <span>Candidate ID</span>

              <span>
                {responseData?.data
                  ?.candidate_id}
              </span>
            </div>
          ) : (
            <div className={styles.row}>
              <span>Lead ID</span>

              <span>
                {responseData?.data
                  ?.can_lead_id}
              </span>
            </div>
          )} */}

          {/* TIMELINE */}
          <div className={styles.timelineCard}>

            <h4 className={styles.timelineTitle}>
              Last Timeline Entry
            </h4>

            <div className={styles.row}>
              <span>Notes</span>

              <span title={responseData?.data?.lastDataEntry?.notes}>
                {textTruncate(responseData?.data
                  ?.lastDataEntry?.notes , 30) || "-"}
              </span>
            </div>

            <div className={styles.row}>
              <span>Last Updated</span>

              <span>
                {dateFormateDD(
                  responseData?.data
                    ?.lastDataEntry
                    ?.created_time
                )}
              </span>
            </div>

          </div>

        </div>
      )}
     </div>
    </div>
  );
};

export default CheckCandidateStage;